import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// StrictMode removed — GSAP timelines are incompatible with StrictMode's
// intentional double-mount in development (it fires cleanup/kill before
// the animation finishes, so onComplete never fires and the page stays black)
root.render(<App />);

// Register service worker for PWA / offline support
serviceWorkerRegistration.register();
